import Home from '@pages/Home/Home';
import Auth from '@pages/Auth/Auth';
import Brands from '@pages/Brands';
import AddBrand from '@pages/AddBrand';
import EditBrand from '@pages/EditBrand';
import Points from '@pages/Points';
import AddPoint from '@pages/AddPoint';
import EditPoint from '@pages/EditPoint';
import Products from '@pages/Products';
import AddProduct from '@pages/AddProduct';
import EditProduct from '@pages/EditProduct';
import Profile from '@pages/Profile';
import Catalogues from '@pages/Catalogues';
import AddCatalogue from '@pages/AddCatalogue';
import EditCatalogue from '@pages/EditCatalogue';
import { NotFound } from '@components/Core/NotFound';
import { RouteItem } from '@components/Core/CustomRoute/types';

export const commonRoutes: RouteItem[] = [
  { path: '/', component: <Home />, isPrivate: true },
  { path: '/login', component: <Auth />, disableNavbar: true },
  { path: '/profile', component: <Profile />, isPrivate: true },
  { path: '/add-brand', component: <AddBrand />, isPrivate: true },
  { path: '*', component: <NotFound /> },
];

export const businessRoutes: RouteItem[] = [
  { path: '/brands', component: <Brands />, isPrivate: true },
  { path: '/brands/:brandId', component: <EditBrand />, isPrivate: true },
  { path: '/brands/:brandId/points', component: <Points />, isPrivate: true },
  { path: '/brands/:brandId/add-point', component: <AddPoint />, isPrivate: true },
  { path: '/brands/:brandId/points/:pointId', component: <EditPoint />, isPrivate: true },
  { path: '/brands/:brandId/products', component: <Products />, isPrivate: true },
  { path: '/brands/:brandId/add-product', component: <AddProduct />, isPrivate: true },
  { path: '/brands/:brandId/products/:productId', component: <EditProduct />, isPrivate: true },
  { path: '/brands/:brandId/catalogues', component: <Catalogues />, isPrivate: true },
  { path: '/brands/:brandId/add-catalogue', component: <AddCatalogue />, isPrivate: true },
  {
    path: '/brands/:brandId/catalogues/:catalogueId',
    component: <EditCatalogue />,
    isPrivate: true,
  },
];
